<template>
  <div id="login">
    <div class="login_box" v-bind:style="{ 'background-image': 'url(' + backgroundImage + ')' }">
      <div class="login_cont">
        <div class="login_contRight right">
          <!--<div class="login_header">
            <p class="login_back login_active">登录</p>
            <p class="register_back" @click="goRegister">注册</p>
          </div>
          <div class="login_footer login">
            <input type="tel" placeholder="请输入用户名/手机号" v-model="loginName" maxlength="11">
            <input type="password" v-model="loginPass" placeholder="请输入登录密码">
            <input type="text" v-model="loginCode" placeholder="前请输入图形验证码">
            <s-identify
              class="picCode"
              :identifyCode="identifyCode"
              :contentWidth="97"
              :contentHeight="41"
              @refreshcode="getRePicCode"
            ></s-identify>
            <p class="login_p">
              <span class="left">
                <input type="checkbox" v-model="loginRememeber">记住用户名
              </span>
              <router-link class="right" to="/login/forgetpass" active-class="Active">忘记密码</router-link>
            </p>
            <button class="login_btn" @click="login">登录</button>
          </div>-->
          <el-card class="box-card" style="height: 100%">
            <div slot="header" class="clearfix">
              <span style="color: #409EFF">{{ $t('login.userLogin') }}</span>
            </div>
            <div class="content">
              <el-form ref="form">
                <el-form-item>
                  <el-input v-model="loginName" :placeholder="$t('login.enterUsername')"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input show-password v-model="loginPass" :placeholder="$t('login.enterPassword')"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-row>
                    <el-col :span="14">
                      <el-input v-model="loginCode" :placeholder="$t('login.enterCaptcha')"></el-input>
                    </el-col>
                    <el-col :span="10">
                      <!-- <s-identify :identifyCode="identifyCode" class="login_img"
                                  :contentWidth="150"
                                  :contentHeight="40"
                                  @refreshcode="getRePicCode"></s-identify> -->
                      <img :src="captcha" class="login_img" height="150" width="40" @click="getCaptcha()">

                      </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item v-if="isSimulateBtn == 1">
                  <el-row>
                    <el-col :span="5">
                      {{ $t('field.Login_freeTrial') }}
                    </el-col>
                    <el-col :span="19">
                      <el-switch v-model="isSimulate" active-color="#1082ff"></el-switch>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item style="margin: 0">
                  <div>
                    <el-row>
                      <el-col :span="12">
                        <span class="auxiliary left">
                          {{ $t('login.dontHaveAccount') }}
                          <router-link to="/login/register" style="color: var(--baseColor)">
                            {{ $t('login.registerkey') }}
                          </router-link>
                        </span>
                      </el-col>
                      <el-col :span="6">
                        <span class="auxiliary center-div" style="color: var(--baseColor);" @click="openForgetLoginName">
                          {{ $t('login.forgotLoginName') }}?
                        </span>
                      </el-col>
                      <el-col :span="6">
                        <span class="auxiliary right">
                          <router-link style="color: var(--baseColor)"  to="/login/forgetpass" active-class="Active">{{ $t('login.forgotPass')}}</router-link>
                        </span>
                      </el-col>
                    </el-row>
                  </div>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" style="width: 100%;background-color: var(--baseColor);border-color:var(--baseColor)" @click="login">{{ $t('login.loginkey') }}</el-button>
                </el-form-item>
              </el-form>
            </div>

          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import $ from "jquery";
import SIdentify from "../components/icode";
import md5 from 'js-md5';
import JSEncrypt from 'jsencrypt/bin/jsencrypt';
import { version,description } from "../../package";
import eventBus from "../assets/js/eventBus";
import axios from "axios";
import { buildConfigs } from "../../static/config"; "../../static/config"; 

export default {
  name: "Login",
  components: {
    SIdentify
  },
  activated() {
    var c = document.getElementById("canvas");
    var cxt = c.getContext("2d");
    c.height = c.height;
  },
  data() {
    return {
      isSimulate: false,
      loginName: localStorage.getItem("name") || "", //登录_账号
      loginPass: "", //登录_密码
      loginCode: "", //登录_验证码
      identifyCode: "", //注册_图形验证码图片
      identifyCodes: "123456789",
      loginRememeber: localStorage.getItem("rememberName") || false, //登录_记住密码 true：记住 false 不记住
      captcha: '',
      verify_token: '',
      backgroundImage: '',
      isSimulateBtn:0
    };
  },
  mounted: function () {
    this.getSimulateValue();
    this.isLogin();
    this.getCaptcha();

    if (window.location.href.includes("/login")) {
      localStorage.setItem("chatUpdated", false);
      // localStorage.setItem("systemMessages", "");
      // localStorage.setItem("systemUnread", 0);
      eventBus.$emit('updateTotalCount');
      eventBus.$emit("endChat");
    }
    
    let that = this;
    //监听回车事件
    document.onkeydown = function (e) {
      let kev = document.all ? window.event : e;
      if (kev.keyCode === 13) {
        that.login()
      }
    };
    this.getBackgroundImage();
  },
  watch: {
    isSimulate(newV, oldV) {
      // this.$store.commit('updateSimulateState', newV);
      localStorage.setItem('isSimulation',newV)
    }
  },
  methods: {
    getSimulateValue() {
      let that = this;
      that
        .$http({
          url: "/app/Home/configs",
          method: "post",
          data: {
            
          }
        })
        .then(function (res) {
          if (res.data.status == 200) {
           

            if (res.data.status == 200) {
              that.isSimulateBtn = parseInt(res.data.data.simulate_user_enable);
            } else {
              
            }
          } else {
            
          }
        });
    },
    getBackgroundImage() {
      let that = this;
      that
        .$http({
          url: "/app/Sysconfig/sysconfig/name",
          method: "post",
          data: {
            name: "pc_login_background_image",
          },
          transformRequest: [(data) => JSON.stringify(data)]
        })
        .then(function (res) {
          if (res.data.status == 200) {
            that.backgroundImage = res.data.data.replace(/ /g, "%20");
          }
        });
    },
    isLogin() {
      if (this.$store.state.loginType) {
        this.$router.push({
          path: "/myaccount"
        });
      }
    },
    openForgetLoginName() {
      this.$router.push({
        path: "/login/Forgetusername"
      })
    },
    goRegister() {
      this.$router.push({
        path: "/login/register"
      });
    },
    getCaptcha() {
      let that = this;
      that.$http({
        url: "/app/SendSms/getSmsPic",
        method: "post",
        data: {

        },
      })
        .then(function (res) {
          let resData = res.data;
          if (resData.status == 200) {
            that.captcha = "data:image/png;base64," + resData.data.data.img;
            that.verify_token = resData.data.data.key;
          } else {
            that.disabled = false;
            that.$message.error(that.$t(res.data.msgId));
          }
        });
      // this.captcha = 'https://server.hk9999z.com/captcha?v='+Math.random();
    },
    //获取注册 图片验证码
    getRePicCode() {
      this.loginCode = "";
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    // 生成一个随机数
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    //更新验证码
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    //创建图形验证码
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
    },
    loginService() {
      let accountNumber = localStorage.getItem("user_number");
      let password = localStorage.getItem("password");
      this
        .$http({
          url: this.$chatApiURL + "/api/user/login",
          method: "post",
          data: {
            account: accountNumber,
            password: md5(password)
          }
        })
        .then(function (res) {
          if (res.data.code == 200) {
            window.localStorage.chatToken = res.data.token;
          }
        });
    },
    login() {
      let that = this;
      // if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(that.loginName)) {
      //   that.$message.error(that.$t('login.phoneFormatIncorrect'));
      // } else if (that.loginPass == "") {
      //   that.$message.error(that.$t(login.enterPassword));
      // } 
      // else if (that.loginCode != that.identifyCode) {
      //   that.getCaptcha();
        // that.$message.error(that.$t('login.captchaIncorrect'));
      // } 
      if (that.loginName == "") {
        that.$message.error(that.$t('registerPc.pleaseEnterUsername'));
      } 
      else if (that.loginPass == "") {
        that.$message.error(that.$t('login.passwordError'));
      } 
      else {

        // let publicKey = localStorage.getItem('encript_public_key')
        // let userName = that.loginName.toString();
        // let loginPhone = that.encryptMessage(userName, publicKey)
        // let loginPassword = that.encryptMessage(that.loginPass, publicKey)

        that
          .$http({
            url: "/app/User/login",
            method: "post",
            data: {
              user_name: that.loginName,
              password: that.loginPass,
              app_version: version,
              is_simulate: that.isSimulate ? 1 : 0,
              rePicCode:that.loginCode,
              verifyToken: that.verify_token,
              build_type: window.__env.buildType,
              build_number: description
            },
            transformRequest: [(data) => JSON.stringify(data)]
          })
          .then(function (res) {
            if (res.data.status == 200) {
              // that.$store.commit('updateSimulateState', that.isSimulate == 1);
              localStorage.setItem('isSimulation',that.isSimulate == 1)
              that.$message({
                message: that.$t(res.data.msgId),
                type: "success",
                duration: 1000
              });
              window.sessionStorage.setItem("loginType", true);
              let user_number = res.data.data.user_number;
              localStorage.setItem("user_number", user_number);
              localStorage.setItem("password", that.loginPass);
              localStorage.setItem("uid", res.data.data.uid);
              that.$store.commit("changeLoginType", true);
              eventBus.$emit("startChat")
              that.getAgentList();
              // that.loginService();

              that.$router.push({
                path: "/myaccount"
              });
              // if(that.isSimulate){
              //   window.sessionStorage.setItem("simulateToken", res.data.data.token);
              // }else{
              //   window.sessionStorage.setItem("token", res.data.data.token);
              // }
              window.sessionStorage.setItem("token", res.data.data.token);
              if (that.loginRememeber == true) {
                window.localStorage.setItem("name", that.loginName);
                window.localStorage.setItem("rememberName", true);
              } else {
                localStorage.removeItem("name");
                localStorage.removeItem("rememberName");
              }
            } else {
              that.rePicCode= "";
              that.getCaptcha();
              that.loginCode = "";
              that.$message.error(that.$t(res.data.msgId));
            }

            that.getClientIp();
          });
      }
    },
    getClientIp() {
      let context = this;
      var clientIp;
      axios
        .get('https://ifconfig.me/all.json')
        .then((response) => {
          clientIp = response.data.ip_addr;
          console.log('IP',clientIp)
          context.updateUserIp(clientIp);
        })
        .catch(() => {
          console.log('Primary IP fetch failed');
          context.getConfigIPUrl().then((configString) => {
            if (configString) {
              let parts = configString.split(',');
              let url = parts[0].trim();
              let field = parts[1].trim();

              axios
                .get(url)
                .then((response) => {
                  clientIp = response.data[field]; 
                  console.log('Config URL IP', clientIp);
                  context.updateUserIp(clientIp);
                })
                .catch(() => {
                  console.error('Config URL IP fetch failed.');
                });
            } else {
              console.error('Config URL IP config not in expected format (url,field)');
            }
          });
        });
    },
    getConfigIPUrl() {
      return this.$http({
        url: "/app/Sysconfig/sysconfig/name",
        method: "post",
        data: {
          name: "login_ip_get_gateway"
        }
      }).then(function (res) {
        if (res.data.status === 200) {
          console.log('res',res.data.data)
          return res.data.data; 
        } else {
          return null;
        }
      }).catch(function () {
        return null;
      });
    },
    updateUserIp(ip) {    
      let context = this;
      context.$http({
        url: 'app/User/update_ip',
        method: 'post',
        data: {
          type: 0,
          clientIp: ip
        },
      }).then(res => {
        console.log("IP Updated.");
      })
    },
    encryptMessage(message, publicKey) {
      const jsEncrypt = new JSEncrypt();
      jsEncrypt.setPublicKey(publicKey);
      return jsEncrypt.encrypt(message);
    },
    getAgentList() {
      let that = this;
      that
        .$http({
          url: "/app/Chat/agentList",
          method: "post",
          data: {},
          chatUrl: true,
          transformRequest: [(data) => JSON.stringify(data)]
        })
        .then(function (res) {
          if (res.data.status == 200) {
            const chatList = res.data.data;
            chatList.forEach(element => {
              element.messages = [];
            })
            localStorage.setItem("agent_list", JSON.stringify(chatList))
            if (chatList.length > 0) {
              that.getChatHistory()
            }
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    getChatHistory() {
      let that = this;
      that
        .$http({
          url: "/app/Chat/getHistory",
          method: "post",
          data: {
            user_id: localStorage.getItem("uid")
          },
          chatUrl: true,
          transformRequest: [(data) => JSON.stringify(data)]
        })
        .then(function (res) {
          if (res.data.status == 200) {
            let msgList = res.data.data;
            // msgList = msgList.filter(element => element.is_read == 1);

            msgList.sort((a, b) => b.timestamp - a.timestamp);

            const systemMessages = msgList.filter(element => element.sender === "SYSTEM")
            that.handleSystemMessage(systemMessages)
            
            const setMessagePromises = msgList.map(element => that.setMessageList(element));

            Promise.all(setMessagePromises).then(res => {
              const msgListReversed = msgList.reverse();

              // Set the count
							const messageAgents = JSON.parse(localStorage.getItem('agent_list'));
              const uid = localStorage.getItem('uid');
							messageAgents.forEach(element => {
                const unreadMsgs = element.messages.filter(item => item.is_read != 1 && item.receiver == uid && item.type != -100);
                element.count = unreadMsgs.length;
              });
              localStorage.setItem("agent_list", JSON.stringify(messageAgents));
							eventBus.$emit("updateTotalCount");

              if (msgListReversed.length) {
                msgListReversed.every(item => {
                  if ((item.is_read == 1 || item.is_read == 2) && item.receiver != 'SYSTEM') {
                    localStorage.setItem('last_msg_id', item.order_id);
                    localStorage.setItem('last_msg_receiver', item.receiver);
                    return false;
                  } else {
                    localStorage.setItem('last_msg_id', '');
                    localStorage.setItem('last_msg_receiver', '');
                    return true;
                  }
                })
              } else {
                localStorage.setItem('last_msg_id', '');
                localStorage.setItem('last_msg_receiver', '');
              }
              localStorage.setItem("chatUpdated", true);
            })
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    setMessageList(messageItem) {
      return new Promise((resolve, reject) => {
        let agentList = JSON.parse(localStorage.getItem('agent_list'));
        agentList.forEach((element, index) => {
          if (element.number == messageItem.receiver || element.number == messageItem.sender) {
            element.messages.push(messageItem);
            element.last_msg = messageItem;
          }
          // Resolve at the last message
          if (index === agentList.length - 1) {
            localStorage.setItem("agent_list", JSON.stringify(agentList));
            resolve();
          }
        });

        // If list is empty
        if (agentList.length === 0) {
          localStorage.setItem("agent_list", JSON.stringify(agentList));
          resolve();
        }
      })
    },
    handleSystemMessage(systemMessages) {
      if (systemMessages) {
        const systemMsgOnLogin = localStorage.getItem("systemMessages")
        systemMessages.forEach((message) => {
        
          const availableMessages = localStorage.getItem("systemMessages") ? JSON.parse(localStorage.getItem("systemMessages")) : [];
          const messageAvailable = availableMessages.length ? availableMessages.find(element => element.order_id == message.order_id) : false;

          if (!messageAvailable) {
            if (systemMsgOnLogin) {
              message.readStatus = false;
              let updatedCount = localStorage.getItem("systemUnread");
              updatedCount = updatedCount && !isNaN(updatedCount) ? parseInt(updatedCount, 10) : 0;
              const systemMessageUnreadCount = parseInt(updatedCount) + 1;
              localStorage.setItem('systemUnread', systemMessageUnreadCount);
            } else {
              message.readStatus = true
            }
            availableMessages.push(message)
            localStorage.setItem("systemMessages", JSON.stringify(availableMessages))

            // eventBus.$emit("onChatReceived", message);
          }
        })
      }
    }
  },
  beforeDestroy() {
    document.onkeydown = function (e) {
      var key = document.all ? window.event : e;

      if (key.keyCode === 13) {

      }
    }
  }
};
</script>
<style scoped>
@import url("./../assets/css/login.css");
.picCode {
  display: inline-block;
  width: 97px;
  height: 41px;
  position: absolute;
  right: 78px;
  top: 248px;
}
.content{
  width: 80%;
  margin: 0 auto;
  /*text-align: center;*/
}
  .auxiliary{
    cursor: pointer;
    /* color: #0000EE; */
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/login.vue